namespace RioERP.Masters {
    export namespace WhatsAppTemplateVariableMapService {
        export const baseUrl = 'Masters/WhatsAppTemplateVariableMap';

        export declare function Create(request: Serenity.SaveRequest<WhatsAppTemplateVariableMapRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<WhatsAppTemplateVariableMapRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<WhatsAppTemplateVariableMapRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<WhatsAppTemplateVariableMapRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Masters/WhatsAppTemplateVariableMap/Create",
            Update = "Masters/WhatsAppTemplateVariableMap/Update",
            Delete = "Masters/WhatsAppTemplateVariableMap/Delete",
            Retrieve = "Masters/WhatsAppTemplateVariableMap/Retrieve",
            List = "Masters/WhatsAppTemplateVariableMap/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>WhatsAppTemplateVariableMapService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
